import { Users, ShieldCheck, Video, Sparkles, FileText } from 'lucide-react';
import { StatCard } from './shared';

export const AdminStats = ({ stats }) => {
  if (!stats) return null;
  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
      <StatCard icon={Users} label="Users" value={stats.users_total} accent="bg-indigo-500/10 text-indigo-300" />
      <StatCard icon={ShieldCheck} label="Admins" value={stats.admins_total} accent="bg-amber-500/10 text-amber-400" />
      <StatCard icon={Video} label="Videos" value={stats.videos_total} accent="bg-purple-500/10 text-purple-300" />
      <StatCard icon={Sparkles} label="Generations" value={stats.generations_total} accent="bg-pink-500/10 text-pink-300" />
      <StatCard icon={FileText} label="Presets" value={stats.presets_total} accent="bg-emerald-500/10 text-emerald-300" />
    </div>
  );
};
